import { Renderer, RenderingContext } from "fmko-ts-grid";
import TestGroupWidget from "./TestGroupWidget";

export default class TestGroupRenderer implements Renderer {
    public render(ctx: RenderingContext, o: Object) {
        let groupName = <string>o;
        let widget = new TestGroupWidget(groupName);
        ctx.setWidget(widget);
    }

    public canRender(o: Object): boolean {
        return true;
    }

}
